import React, { useContext, useEffect, useState } from 'react';
import axios from "axios";

import { useHistory, useLocation } from 'react-router-dom'

import { SettingsContext } from '../../contexts'
import { ProductSearchForm } from "../../forms"
import { ProductList, SubmitButton } from "../../components"
import { ProductPreview } from '../../product/components';

const Product = ({
  product: productProp,
  productId,
  limit,
  firstPageOnly,
  showSearchMore = false,
  defaultFilters,
  requestType,
  onProductSelected,
  hidden = false,
}) => {
  const history = useHistory()
  const location = useLocation()
  const settings = useContext(SettingsContext)

  const [ product, setProduct ] = useState(productProp);
  const [ filters, setFilters ] = useState(defaultFilters)

  useEffect(() => {
    if (productProp?.id === productId) {
      setProduct(productProp);
      return;
    }

    setProduct(null)

    if (productId === 'not-found') {
      setProduct({})
      return
    }

    if (location.data?.product) {
      setProduct(location.data?.product)
      return
    }

    if (productId === 'new') {
      setProduct({})
      return
    }

    if (!productId) {
      return
    }

    const loadProduct = async () => {
      const { data } = await axios.get(`/api/products/${productId}`)
      setProduct(data)
    }

    loadProduct()
  }, [productId])

  const formProps = {
    product,
    submitAction: (filters) => {
      setFilters(filters)
    },
    filters,
  }

  const listProps = {
    filters: filters,
    query: filters?.query,
    onActionButtonClick: onProductSelected,
    limit,
    firstPageOnly,
    requestType,
  }

  return (
    <>
      <ProductSearchForm {...formProps} />

      { filters && (
        <ProductList {...listProps} >
          {showSearchMore && (
            <div className="search-more">
              <SubmitButton
                onClick={() => history.push(
                  `/request/order?${settings.iframeQueryParams}`,
                  { filters, reset: true }
                )}
                label="Search more"
              />
            </div>
          )}
        </ProductList>
      )}

      {!hidden && <ProductPreview onSelect={onProductSelected} />}
    </>
  )
}

export default Product
